import React from 'react';
import { Box, Grid } from '@mui/material';
import UniversalConfirmAction from '../../universal-confirm-action';

const ResponsiveContainer = ({
  dropdowns,
  buttonClass,
  button,
  disableSubmit,
}: {
  dropdowns?: JSX.Element;
  button: {
    id: string;
    clickCallBack: () => Promise<void>;
    doubleCheck?: boolean;
  };
  buttonClass?: string;
  disableSubmit?: boolean | false;
}) => {
  const { id, clickCallBack, doubleCheck } = button;
  return (
    <Grid item xs={12} lg={6}>
      <Box
        display="flex"
        flex-direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Box pb={2} display="flex">
          {dropdowns}
        </Box>
        <Box
          display="flex"
          minWidth={200}
          flexGrow={1}
          justifyContent="flex-start"
          className={buttonClass}
        >
          <UniversalConfirmAction
            id={id}
            clickCallBack={clickCallBack}
            doubleCheck={doubleCheck}
            disabled={disableSubmit}
            buttonName="Sync"
          />
        </Box>
        <Box pr={0.5} display={{ xs: 'none', lg: 'block' }} />
      </Box>
    </Grid>
  );
};

export default ResponsiveContainer;
